module.exports = function(video) {
	'use strict'
	video.directive('videoEditDir',videoEditDir);
	videoEditDir.$inject=['fileReaderImage','addToOther','jQuery','$http','API_URL','cleanObj','$filter','authtokenService','config','$rootScope','$state','getDataService','refreshtokenService','serverError','alertService','postDataService','deleteDataService','putDataService','$timeout','keyPress', 'checkArray', 'reqursiveService','offlineError'];
	function videoEditDir(fileReaderImage,addToOther,jQuery,$http,API_URL,cleanObj,$filter,authtokenService,config,$rootScope,$state,getDataService,refreshtokenService,serverError,alertService,postDataService,deleteDataService,putDataService,$timeout,keyPress, checkArray, reqursiveService, offlineError) {
		return {
			restrict: 'E',
			scope:{
				media:'='
			},
		template: require('./partial/editVideo.html'),
		link: function(scope, ele, $attrs, ctrl) {
			var state ='video';
			// var parent = scope.$eval($attrs.media);
			// console.log(parent)
			scope.videoGet = false;
			scope.config = config;
			scope.existTag = false;
			scope.editMediaCurrent = null;
			scope.titleRequired = false;
			scope.newTagRequired = false;
			scope.attachmentId = scope.media.attachmentId;
			scope.imageLocked = false;
			scope.categorychecked = {item: {}};
			scope.editSlugShow = false;
			scope.copyEditSlug = false;
			scope.copySlug = null;
			scope.uploadedThumb = false;
			Dropzone.autoDiscover = false;
			var updateDate = null;
			var tagPosts = null;
			scope.publishedSlug = null;
			scope.editPostStatusShow = false;
			scope.videoGet = false;
			scope.videoLoaded = false;
			scope.safe = 'safe';
			scope.safeSelected = 0;
			scope.checkedItems = {};
			scope.videoSafeRequired = false;
			scope.videoVersion = scope.config.videoUploadVersion;
    		scope.geoAllowance = config.geoRestrictions;
		    scope.allowCheckedItems = {};
			scope.addToOther = addToOther;
		    var geoAllowanceUpdateFunction = function() {
		      	for(var i=0; i<scope.geoAllowance.length;i++) {
		        	scope.allowCheckedItems[scope.geoAllowance[i]._id] = false;
		      	}
		    }
		    geoAllowanceUpdateFunction();
		    scope.allowCheckedItems[scope.geoAllowance[0]._id] = true;
		    scope.geoAllow = scope.geoAllowance[0]._id;
			var posterDisplayRes;
		    var thumbDisplayRes;
			scope.updateAllowance = function(allowance) {
		    	if(scope.allowCheckedItems[allowance]) {
		      		putGeoAllowanceFunction(allowance);
		    	}
		      	geoAllowanceUpdateFunction();
		      	scope.allowCheckedItems[allowance] = true;
		    }
		    var putGeoAllowanceFunction = function(allowance) {
				var geoUrl;
				if(scope.editMediaCurrent.transcoding_provider == 'mediaoutcast') {
					geoUrl = API_URL + 'video/georestrictions/mediaoutcast/'+ scope.editMediaCurrent._id
				} else {
					geoUrl = API_URL + 'video/georestrictions/'+ scope.editMediaCurrent._id
				}
		      	var updateDataPosts = {
		        	"allowance": allowance,
		        	"video_id": scope.editMediaCurrent.video_id,
		        	"isUpdate": true
		      	}
		      	var putFunction = function() {
		        	$http.put(geoUrl , updateDataPosts)
		        	.success(function (data, status, headers) {
		           		alertService('success','Success ', data.message, 2000);
		           		scope.geoAllow = allowance;
		        	})
		        	.error(function (data, status, header, config) {
						if(!window.navigator.onLine) {
							offlineError()
							geoAllowanceUpdateFunction();
		          			scope.allowCheckedItems[scope.geoAllow] = true;
							alertService('danger','Opps! ', 'Please check your internet connection and try again.');
							return
						}
			          	if(status ==401) {
				            var promise = refreshtokenService.getAccessToken();
				            promise.then(
				              function(answer) {
				                if(answer==200) {   
				                  putFunction();
				                }
				              },
				              function(error) {
				                // report something
				              },
				              function(progress) {
				               // report progress
				            });
			          	}else if(status ==502) {
			            	serverError();
			          	} else {  
			            	alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
			           
			          	}
			          	geoAllowanceUpdateFunction();
		          		scope.allowCheckedItems[scope.geoAllow] = true;
		        	});
		      	}
		      	putFunction();
		    }
			var publishPostFunction = function(url, state, status) {
		      	var validatePublish = true;
		      	var putFunction = function() {
		        
			        if(status=='publish') {
			          scope.editMediaCurrent.status = 'publish'
			          if(scope.scheduledPost) {
			            scope.editMediaCurrent.status = 'schedule';
			          }
			        } else if(status=='trash') {
			          scope.editMediaCurrent.status = 'trash'
			        }
			        var updateDataPost = {
				        'video_id':scope.editMediaCurrent.video_id,
		                'title': (scope.editMediaCurrent.title)? (scope.editMediaCurrent.title).replace(/\r?\n|\r/g, ' '): '',
		                'subtitle': (scope.editMediaCurrent.subtitle)? (scope.editMediaCurrent.subtitle).replace(/\r?\n|\r/g, ' '): '',
		                'category':scope.category,
		                'tags': tagPosts,
		                'file':scope.editMediaCurrent.file,
		                'image': scope.image,
		                'custom_image':scope.customThumbsLocked,
		                'thumbs':scope.thumbsLocked,
		                'signature':scope.editMediaCurrent.signature,
		                'status': scope.editMediaCurrent.status,
		                "date": updateDate,
		                "order": scope.editMediaCurrent.order,
						"moderator_guide":scope.editMediaCurrent.moderator_guide,
		                "meta" : {
		                	"safe": scope.safe
		                },
		                "allowance":scope.geoAllow
					}
					if( scope.postSlug != scope.copySlug) {
						updateDataPost.slug = scope.postSlug;
						if(!updateDataPost.slug) {
							updateDataPost.slug = ''
						}
						updateDataPost.meta.autoslug = 'false';
					}
			        cleanObj.clean(updateDataPost);
			        var updateFunction = function() {
			        	$rootScope.hasLoaded = false;
			            $http.put(url , updateDataPost)
			            .success(function (data, stat, headers) {
			              	updateDataPost = {};
			              	$rootScope.hasLoaded = true;
			                if(status=='trash') {
			                  scope.media.editVideoShow = false;
			                  $state.transitionTo('app.allvideos', {id: null}, {
			                    location: true,
			                    inherit: true,
			                    relative: $state.$current,
			                    notify: false
			                  });
			                }else {
			                	getVideoCategoriesFunction();
			                } 
			              	alertService('success','Success ', data.message, 2000);
			            })
			            .error(function (data, status, header, config) {
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
							if(status ==401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
								function(answer) {
									if(answer==200) {   
									updateFunction();
									}
								},
								function(error) {
								},
								function(progress) {
								// report progress
								});
							}else if(status ==502) {
								if(state=="save") {
								serverError()  
								}
							} else if(status==400) {
								scope.scheduledPost = false;
								scope.editMediaCurrent.status = 'draft';
								alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
							} else { 
								if(state=="save") {
								alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
								}
							}
							updateDataPost = {};
							$rootScope.hasLoaded = true;
			            });
		        	}
		        	updateFunction();
			    }
		      
			    if(scope.editMediaCurrent.tags.length>0) {
			        scope.newTagRequired = false;
			        tagPosts = scope.editMediaCurrent.tags
			    } else {
			      	validatePublish = false;
			      	scope.newTagRequired = true;
			      	tagPosts = null;
			    }
		      if(scope.editSlugShow) {
						validatePublish = false;
						alertService('danger','Opps! ', 'Cancel or edit permalink');
					}
		    
					if(scope.editMediaCurrent.title) {
						scope.titleRequired = false;
					} else {
						scope.titleRequired = true;
						alertService('danger','Opps! ', 'Title is required');
						validatePublish = false;
					}
					if(scope.titleExceed) {
						validatePublish = false;
						alertService('danger','Opps! ', 'Maximum number of characters in title is 100');
						}
					if(!updateDate) {
						updateDate = moment().toISOString();
					}
					if(scope.category) {
						scope.categoryRequired = false;
					} else {
						scope.categoryRequired = true;
						alertService('danger','Opps! ', 'Category is required')
						validatePublish = false;
					}
					if(!scope.safe) {
						scope.videoSafeRequired = true;
						validatePublish = false;
						alertService('danger','Opps! ', 'Video safety is required')
					} else {
						scope.videoSafeRequired = false;
					}
					if(validatePublish) {
						putFunction();
					}
		        
		    }
			function getSaveUrl() {
				if(scope.editMediaCurrent.transcoding_provider == 'mediaoutcast') {
					return API_URL + "video/mediaoutcast/"+scope.editMediaCurrent._id
				} else {
					return API_URL + "video/"+scope.editMediaCurrent._id
				}
			}
		    scope.publishPost = function() {
				var url = getSaveUrl()
		      	publishPostFunction(url, 'save', 'publish');
		    }
		    scope.trashPost = function() {
				var url = getSaveUrl()
		      publishPostFunction(url, 'save', 'trash');
		    }
		    scope.updateorSavePost =  function() {
				var url = getSaveUrl()
		      publishPostFunction(url, 'save', undefined);
		    }
			scope.dzOptionsThumb = {
				url : 'https://upload.telegraf.tv',
		        paramName : 'filename',
		        maxFilesize : '500000',
		        parallelUploads: 1,  
		        acceptedFiles : 'image/jpeg, images/jpg',
		        addRemoveLinks : true,
		        autoProcessQueue : false,
		        dictInvalidFileType: 'This file type is not supported.',
		        dictFileTooBig:'File size too Big',
		        dictDefaultMessage : "Drop image here to upload",
		        headers:{
		          'x-auth': null  
		        },       
		    };
		    scope.dzCallbacksThumb = {
				'processing': function(file) {
					var dz =scope.dzMethodsThumb.getDropzone();
					var uploadThumbUrl;
					if(scope.editMediaCurrent.transcoding_provider == 'mediaoutcast') {
						uploadThumbUrl = 'https://upload.telegraf.tv/api/mediaoutcast/thumb/update'
					} else {
						uploadThumbUrl = 'https://upload.telegraf.tv/api/'+scope.videoVersion+'/thumb/update'
					}
					dz.options.url= uploadThumbUrl
				}, 
		        'addedfile' : function(file){
					fileReaderImage(file,function(width,height){
						if (((scope.editMediaCurrent.orientation=='portrait') &&  (width < 541 || height < 961)) || 
            				((scope.editMediaCurrent.orientation!='portrait') &&  (width < 816 || height < 459))) {
							scope.dzMethodsThumb.removeFile(file);
							var imageDimensions = (scope.editMediaCurrent.orientation=='portrait')? '541x961':'816x459'
							alertService('danger','Opps! ', "Image dimensions are too small (min-dimensions:"+ imageDimensions +"). The file has been removed.");
						} else {
							uploadFile()
						}
					})
					function uploadFile() {
						scope.newFileThumb = file;
						var promise = refreshtokenService.getAccessToken();
						promise.then(
						function(answer) {
							var token = authtokenService.getToken();
							scope.dzOptionsThumb.headers['x-auth'] = token;
							scope.dzMethodsThumb.processQueue();
						},
						function(error) {
							// report something
						},
						function(progress) {
						// report progress
						});
					}
		        },
		        'success' : function(file, xhr, response){
		        	var data = JSON.parse(response.currentTarget.response);
		            scope.customThumb = data.image;
		            scope.customThumbsLocked = angular.copy(data.image); 
			
		            scope.uploadedThumb = true;
		            if(scope.thumbsLocked.length != scope.thumbs.length) {
		                scope.thumbs.splice(-1,1); 
		            }
					scope.thumbs.push(scope.config.baseVideoHref + scope.customThumb.replace('.jpg',thumbDisplayRes));
		            scope.selectedImage = scope.thumbs.length-1;
		            scope.image = scope.customThumbsLocked;
		            // jQuery('.vjs-poster').css('background-image', 'url('+scope.config.baseVideoHref + scope.image.replace('.jpg','-620x350.jpg')+')')
		        	scope.player.poster(scope.config.baseVideoHref + scope.image.replace('.jpg','-620x350.jpg'));
		        },
		        'error' : function(file,message) {
					if(message && message.error && message.error.message) {
						jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
					}
		        },
		        'sending':function(file, xhr, formData) {
		        	formData.append('video_id', scope.editMediaCurrent.video_id);
            		formData.append('date', scope.date);
					formData.append('dir', scope.thumbDir);
		            // if(scope.upload_title) {
		            //     formData.append('title', scope.upload_title);
		            // }
		            // if(scope.upload_signature) {

		            //     formData.append('signature', scope.upload_signature);
		            // }
		            // if(scope.upload_description) {
		            //     formData.append('description', scope.upload_description);
		            // }
		        }
		    };
		    scope.dzMethodsThumb = {

		    }
		    scope.updateSafety = function(safeId, checked) {
		    	// scope.safe = safeId;
		    	if(checked) {
			        for(var i = 0; i<scope.addSafety.length;i++) {
			          scope.checkedItems[scope.addSafety[i]._id] = false
			        }
			        scope.checkedItems[safeId]= true;
			        scope.safe = safeId;  
			      } else {
			        scope.safe = null;
			      }	
		    }
		    scope.chooseImage = function(index) {
	            scope.selectedImage = index;
	            if(scope.thumbs.length == scope.thumbsLocked.length) {
	            	scope.image = scope.thumbsLocked[index] 
	            } else {
	            	if(index==scope.thumbs.length-1) {
	                scope.image = scope.customThumbsLocked;
	            	} else {
	                	scope.image = scope.thumbsLocked[index];
	            	}
	            }
	            // jQuery('.vjs-poster').css('background-image', 'url('+scope.config.baseVideoHref + scope.image.replace('.jpg','-620x350.jpg')+')')
		    	scope.player.poster(scope.config.baseVideoHref + scope.image.replace('.jpg',posterDisplayRes));
		    }
		    scope.editPostStatus = function() {
		      scope.editPostStatusShow = true;
		    }
		    scope.changePostStatus = function() {
		      scope.editPostStatusShow = false;
		      scope.editMediaCurrent.status = scope.selectedPostStatus.value;
		    }
		    scope.editPostTime = function() {
		      scope.editPostDateShow = true;
		      if(!scope.pastPost &&!scope.editPublish && !scope.scheduledPost) {
		        convertTimeFunction(undefined);
		      } 
		    }
		    scope.cancelEditPostDate = function() {
		      scope.editPostDateShow = false; 
		    }
		    scope.cancelEditPostStatus = function() {
		      scope.editPostStatusShow = false;
		      scope.selectedPostStatus = {value: scope.editMediaCurrent.status};
		    }
			scope.editSlug = function(slug) {
		      scope.copyEditSlug = angular.copy(slug);
		      scope.editSlugShow = true;
		    }
		    scope.cancelSlug = function() {
		      scope.postSlug = scope.copyEditSlug;
			  if(!scope.postSlug) {
				scope.postSlug = '';
			  } 
		      scope.editSlugShow = false; 
		    }
		    scope.updateSlug = function(slug) {
		      scope.postSlug = slugify(scope.postSlug)
			  if(!scope.postSlug) {
				scope.postSlug = '';
			  }
		      scope.editSlugShow = false; 
		    }
			$rootScope.closeEditVideo = function() {
				scope.media.editVideoShow= false;
				scope.editMediaCurrent = null;
				$state.transitionTo('app.allvideos', {id: null}, {
	              location: true,
	              inherit: true,
	              relative: $state.$current,
	              notify: false
	            });
			}
			scope.searchPress = function(evt) {
		     keyPress(evt);
		    }
		    
	// 	    document.getElementById('source_one').addEventListener('click', function() {
	// 			console.log('ajde');
	// // 			document.getElementById('my-player_html5_api').src = 'http://now.tf.rs/ads/2017/11/13/ads_persen.mp4';
	// 		// 		scope.player.load();
	// 			scope.player.src('http://now.tf.rs/ads/2017/11/13/ads_persen.mp4');
	// 			scope.player.currentTime(20);
	// 			scope.player.play();
	// 			});
			var getVideoCategoriesFunction = function() {
		    	getDataService.get({param1: 'video-categories', tree:1}).$promise.then(function(dataCategory){
						scope.categories = dataCategory.categories;
						scope.categoriesTreeInput = reqursiveService.getReqursiveArray(scope.categories);
			    	getFunction();
			    }, function(error){
					if(!window.navigator.onLine) {
						offlineError()
						$rootScope.hasLoaded = true;
						return
					}
			      	if(error.status ==401) {
						var promise = refreshtokenService.getAccessToken();
						promise.then(
							function(answer) {
							if(answer==200) {
								getVideoCategoriesFunction();
							}
						},
						function(error) {
							// report something
						},
						function(progress) {
						// report progress
						});
					} else if(error.status ==502) {
						serverError()
					} else {
						alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
					}
					$rootScope.hasLoaded = true;
			    });
			}  
			getVideoCategoriesFunction();
			scope.updateSelection = function(category_id, checked) {
			  var updateSelectionTree = function(categories) {
			    if(checked) {
			      for (var i=0; i<categories.length; i++){
			        if (categories[i]._id !== category_id) {
			          scope.categorychecked.item[categories[i]._id] = false;
			        }
			      }
			      scope.category = category_id;
			    } else {
			      scope.category = null;
			    }
			  }
			  updateSelectionTree(scope.categoriesTreeInput);   
			}
			var addNewTagFunction = function(data) {
			    scope.newTagRequired = false;
			    if(!checkArray.contains.call(scope.editMediaCurrent.tags,data.tagId)) {
			        scope.editMediaCurrent.tags.push(data.tagId);
			        scope.searchtagfocus = null;
			        scope.existTag = false;
			    } else {
			        scope.existTag = true;
			    }
		    }
		    scope.$on('select-tag', function(event,data) {
		      	addNewTagFunction(data.selectedTagObj)
		    });
		    scope.addNewTag = function() {
		      	if(scope.searchtagfocus && scope.searchtagfocus.length>1) {
		        	var postFunction = function() {
			          	postDataService.save({
			            	param1:'video-tags', 
			            	// param2: 'create'
			          	},{
			            	'name': scope.searchtagfocus
			          	}).$promise.then(function(postTag){
			          		var data = {
			            	tagId:postTag.tag._id,
			            	tagname: postTag.tag.name
			          		} 
			            	addNewTagFunction(data);
			          	}, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
			            	if(error.status ==401) {
				              	var promise = refreshtokenService.getAccessToken();
				              	promise.then(
				                function(answer) {
				                  if(answer==200) {   
				                    postFunction();
				                  }
				                },
				                function(error) {
				                },
				                function(progress) {
				                 // report progress
				              	});
				            } else if(error.status ==502) {
				              	serverError()
				            } else if(error.status ==400) {
				              	var data = {
					            tagId:error.data.tag._id,
					                tagname: error.data.tag.name
					            } 
				              	addNewTagFunction(data);
				            }
			          	});
		        	}
		        	postFunction();
		      	} else {
		        	scope.newTagRequired = true;
		      	}
		    }
		    scope.removeFromTagsList = function(index) {
		      	scope.editMediaCurrent.tags.splice(index, 1);
		    }
		    scope.setPublishedDate = function() {
		      scope.editPostDateShow = false; 
		      // scope.scheduledPost = false;
		      var dateArray = [scope.postYear, parseInt(scope.selectedPostMont.value)-1, scope.postDay, scope.postHours, scope.postMinutes];
		      updateDate = moment(dateArray).toISOString();
		      if(moment.duration(moment(dateArray).diff(moment())).asMinutes()>5) {
		        scope.scheduledPost = true;
		      } else if(moment.duration(moment(dateArray).diff(moment())).asMinutes()<=5 && moment.duration(moment(dateArray).diff(moment())).asMinutes()>-5 && !scope.editPublish) {
		          updateDate = moment().toISOString();
		          scope.scheduledPost = false;
		          scope.pastPost = false;
		      }
		      else {
		          scope.pastPost = true;
		          scope.scheduledPost = false;
		      }
		      scope.editMediaCurrent.date = $filter('date')(updateDate, "MMM d, y HH:mm");
		    }
		    var convertTimeFunction = function(date) {
		      var a = moment(date);
		      var year = a.format('YYYY');
		      var month = a.format('M');
		      var day = a.format('D');
		      var hour = a.hours();
		      var min = a.minutes();
		      var sec = a.seconds();
		      scope.postYear = year;
		      scope.selectedPostMont = {value: month};
		      scope.postDay = day;
		      if(hour<10) {
		        scope.postHours = '0'+hour;  
		      } else {
		        scope.postHours = hour;
		      }
		      if(min<10) {
		        scope.postMinutes = '0'+min;  
		      } else {
		        scope.postMinutes = min;
		      }
		    }
		    scope.getVideoFunction = function() {
		    	scope.selectedPostStatus={value:scope.editMediaCurrent.status};
		    	updateDate = null;
		    	scope.pastPost = false;
		      	scope.scheduledPost = false;
		      	scope.editPublish =false;
		      	scope.postSlug = '';
		      	scope.copySlug = '';
		      	scope.previewHash = null;
		      	scope.substringUri = null;
				posterDisplayRes = (scope.editMediaCurrent.orientation=='portrait')? '-360x640.jpg':'-620x350.jpg';
				thumbDisplayRes = (scope.editMediaCurrent.orientation=='portrait')? '-360x640.jpg':'-254x191.jpg';
		      	if(scope.editMediaCurrent.status == 'publish') {
			        scope.editPublish = true;
			        if(scope.editMediaCurrent.date) {
			          updateDate = scope.editMediaCurrent.date;
			        }
			    }else if(scope.editMediaCurrent.status=='trash') {
			        scope.media.editVideoShow = false;
			        $state.transitionTo('app.allvideos', {id: null}, {
			          location: true,
			          inherit: true,
			          relative: $state.$current,
			          notify: false
			        });
					return
			    } else if(scope.editMediaCurrent.status=='schedule') {
			        scope.scheduledPost = true;
			        if(scope.editMediaCurrent.date) {
			          updateDate = scope.editMediaCurrent.date;
			        }
			    }
		     	if(scope.editMediaCurrent.date) {
		        	scope.editMediaCurrent.date = $filter('date')(scope.editMediaCurrent.date, "MMM d, y HH:mm");
		        	convertTimeFunction(scope.editMediaCurrent.date);
		      	}
		    	scope.editMediaCurrent.video_file = scope.config.baseVideoHref + scope.editMediaCurrent.file.m3u8;
		     	scope.editMediaCurrent.tags = checkArray.removeDuplicate(scope.editMediaCurrent.tags);
		     	
		     	scope.thumbs = scope.editMediaCurrent.thumbs;
		     	scope.thumbsLocked = angular.copy(scope.editMediaCurrent.thumbs);
		     	if(scope.editMediaCurrent.custom_image) {
		     		scope.uploadedThumb = true;
		     		scope.customThumbsLocked = angular.copy(scope.editMediaCurrent.custom_image); 
		     		scope.thumbs.push(scope.editMediaCurrent.custom_image); 
		     	}
		     	scope.image = scope.editMediaCurrent.image;
		     	scope.selectedImage = scope.thumbs.indexOf(scope.editMediaCurrent.image);
	          	for(var i=0; i<scope.thumbs.length;i++) {
	                scope.thumbs[i]=scope.config.baseVideoHref + scope.thumbs[i].replace('.jpg',thumbDisplayRes); 
				}
				if(scope.editMediaCurrent.file.m3u8.includes('encoded')) {
				// 	scope.videoVersion = 'v1.1'
					scope.dateDefault = scope.editMediaCurrent.file.m3u8.substring(9,19);
				} else {
				// 	scope.videoVersion = 'v1.0'
					scope.dateDefault = scope.editMediaCurrent.file.m3u8.substring(1,11);
				}
				scope.thumbDir = scope.editMediaCurrent.file.m3u8.substring(0, scope.editMediaCurrent.file.m3u8.lastIndexOf('/'));
        		scope.date = scope.dateDefault.replace(/\//g,'-');
	          	if(scope.editMediaCurrent.slug) {
		        	scope.postSlug = scope.editMediaCurrent.slug;
							scope.copySlug = angular.copy(scope.postSlug); 
						
		      	}
		      	if(scope.editMediaCurrent.slug && scope.editMediaCurrent.uri) {
		        	var slugLength = scope.editMediaCurrent.slug.length;
		        	scope.substringUri = scope.editMediaCurrent.uri.substr(0, scope.editMediaCurrent.uri.length-slugLength);
		      	}
		      	if(scope.editMediaCurrent.duration){
                  var formatedTime;
                  if(scope.editMediaCurrent.duration>=3600) {
                    formatedTime = 'H:mm:ss'
                  } else {
                    formatedTime = 'm:ss'
                  } 
                  scope.editMediaCurrent.formated_duration = moment().startOf('day').second(scope.editMediaCurrent.duration).format(formatedTime);
                }
                if(scope.editMediaCurrent.transcoding_status == 0) {
                	scope.transcodingText = "Transcoding in progress..."
                } else if(scope.editMediaCurrent.transcoding_status == -1) {
                	scope.transcodingText = "Transcoding failed"
                } else {
                	scope.transcodingText = "Transcoding success"
                }
                
                scope.addSafety =config.addSafety;
           		if(scope.editMediaCurrent.meta.safe) {
           			for(var i=0;i<scope.addSafety.length;i++) {
           				scope.checkedItems[scope.addSafety[i]._id] = false;
           				if(scope.editMediaCurrent.meta.safe==scope.addSafety[i]._id) {
           					scope.checkedItems[scope.addSafety[i]._id] = true;
           					scope.safe = scope.editMediaCurrent.meta.safe;
           				}
           			}
           		}
           		if(scope.editMediaCurrent.allowance) {
           			geoAllowanceUpdateFunction();
           			scope.allowCheckedItems[scope.editMediaCurrent.allowance] = true;
		      		scope.geoAllow = scope.editMediaCurrent.allowance;
           		}
		      	if(!scope.player) {

			      	scope.videoGet = true;
		            $timeout(function() {

					    // function examplePlugin(options) {
					    //   this.on('play', function(e) {
					    //     console.log('playback has started!');
					    //   });
					    // };
			      //       videojs.registerPlugin('examplePlugin', examplePlugin);
						scope.player = videojs('my-player',
						{
							poster:scope.config.baseVideoHref + scope.image.replace('.jpg',posterDisplayRes),
					      	playbackRates: [0.5, 1, 1.5, 2],
					      	autoplay:false
					  	});
			            scope.player.src({
							src: scope.editMediaCurrent.video_file,
								type: 'application/x-mpegURL',
								withCredentials: false
			            });
			            scope.player.on("play", function() {
			            	scope.$apply(function() {
			            		scope.durationFlag = false;
			            	})
			            });
			            scope.videoLoaded = true;
			            scope.durationFlag = true;
			            
		            },0)
		      	}

		      	if(scope.editMediaCurrent.category) {
			        for (var i=0; i<scope.categoriesTreeInput.length; i++){
			          if (scope.categoriesTreeInput[i]._id === scope.editMediaCurrent.category._id) {
			            scope.categorychecked.item[scope.categoriesTreeInput[i]._id] = true;
			            scope.category = scope.categoriesTreeInput[i]._id;
			          }
			        }
			        $timeout(function() {
			          var checkedCategory = jQuery(".checkedEditPost");
			          if(checkedCategory.length != 0) {
			              var topPos = checkedCategory[0].offsetTop;
			              jQuery('#categoryscroll').animate({scrollTop: topPos-2},600);
			          }
			        },300)
		      	}
			}
		    var getFunction = function() {
			    getDataService.get({param1:state, param2: scope.attachmentId}).$promise.then(function(data){
			     	scope.editMediaCurrent = data;
			     	scope.getVideoFunction();
			     	
			    }, function(error){
					if(!window.navigator.onLine) {
						offlineError()
						$rootScope.hasLoaded = true;
						return
					}
			        if(error.status ==401) {
				        var promise = refreshtokenService.getAccessToken();
				        promise.then(
				          function(answer) {
				            if(answer==200) {
				              getFunction();
				            }
				          },
				          function(error) {
				            // report something
				          },
				          function(progress) {
				           // report progress
				        });
			        }else if(error.status ==502) {
		                serverError();
	                } else {
				        scope.media.editMediaShow= false;
				        $rootScope.hasLoaded = true;
				        $state.transitionTo('app.allvideos', {id: null}, {
			              location: true,
			              inherit: true,
			              relative: $state.$current,
			              notify: false
			            });
			      	}
			    }); 
		    }
		    scope.$on( '$destroy', function() {
			    if(scope.player) {
			    	scope.player.dispose();
			    	scope.player =null;
			    }
			});
			if(!window.navigator.onLine) {
				offlineError('refresh')
				return
			}
		}
	}
}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/video/js/directive/videoEditDirective.js
// module id = 661
// module chunks = 0